<script>
  import { Router, Route } from 'svelte-routing';
  import Header from './components/Header.svelte';
  import Home from './routes/Home.svelte';
  import NavLink from './components/NavLink.svelte';
  import User from './routes/User.svelte';
  import AddUser from './routes/AddUser.svelte';
  import Client from './routes/Client.svelte';
  import TaskLibrary from './routes/TaskLibrary.svelte';
  import TaskLibraryImport from './routes/TaskLibraryImport.svelte';
  import TaskLibraryImportActivityType from './routes/TaskLibraryImportActivityType.svelte';
  import ClientImport from './routes/ClientImport.svelte';
  import UserImport from './routes/UserImport.svelte';
  import ClientFundImport from './routes/ClientFundImport.svelte';
  import Welcome from './routes/Auth/Welcome.svelte';
  import SetupPassword from './routes/Auth/SetupPassword.svelte';

  import Dashboard from './routes/Dashboard.svelte';
  import Notifications from './routes/Notification.svelte';
  import Redirect from './routes/Redirect.svelte';
  import AddClient from './routes/AddClient.svelte';
  import ActivityLog from './routes/ActivityLog.svelte';
  import UserProfile from './routes/UserProfile.svelte';
  import AssignTask from './routes/AssignTask.svelte';
  import Settings from './routes/Settings.svelte';
  import InvalidAccess from './routes/InvalidAccess.svelte';
  import SuccessScreen from './routes/Success.svelte';

  import { client, fetchNewToken } from 'root/api/index.js';
  import { authStore, clearUser, getUserInfo, resetUserData, loginWillExpire } from './stores/auth';
  import { loadingData } from './stores/loadingData';
  import { setContext, onMount, onDestroy } from 'svelte';
  import { navigate } from 'svelte-routing';
  import { setMasterData } from './stores/masterData.js';
  import { setOutlookData } from './stores/outlookData.js';
  import { main } from '@popperjs/core';
  import AlertModel from 'components/Modal/AlertModel.svelte';
  import OverlayModel from 'components/Modal/OverlayModel.svelte';
  import { unreadCount } from './stores/unreadCount.js';
  import { getDashboardData, setDashboardData } from './stores/dashboard.js';

  export let url = '';
  let isLoggedIn = false;
  let publicPage = false;
  let checkState = 'pending';

  let isMasterLoad = false;

  client.checkAuth();
  let userRolesIndex = null;
  let userRoleId = null;
  const getMasterData = () => {
    client
      .getMasterData()
      .then((response) => {
        setMasterData(response.data);
        userRolesIndex = response.data.userRoleId;
        userRoleId = getUserInfo().roleId;
        setDashboardData({
          ...getDashboardData(),
          units: response.data.units || [],
        });
        setOutlookData({
          outlookSetting: response.data.outlookSetting,
        });
      })
      .catch((err) => {})
      .finally(() => {
        checkState = 'success';
      });
  };
  const getUnreadCount = () => {
    client
      .notificationUnreadCount()
      .then((response) => {
        let count = response.data.unreadCount;
        unreadCount.set(count);
        setTimeout(
          () => {
            getUnreadCount();
          },
          1000 * 60 * 1,
        );
      })
      .catch((err) => {});
  };
  const loadMasterData = () => {
    client
      .checkAuth()
      .then(() => {
        isLoggedIn = true;
        getMasterData();
        getUnreadCount();
        resetUserData();
      })
      .catch((err) => {
        isLoggedIn = false;
        checkState = 'error';
        clearUser();
      });
  };

  let draft_status = false;
  let keyboard_listner_status = false;
  const set_draft_status = (status, e) => {
    if (keyboard_listner_status && (e.target.type == 'text' || e.target.type == 'textarea')) {
      draft_status = status;
    }
  };
  window.onkeypress = (e) => set_draft_status(true, e);

  setContext('keyboardListnerStatus', (status) => {
    keyboard_listner_status = status;
    draft_status = false;
  });
  setContext('confirmDraftStatus', (params) => {
    if (draft_status && (params.show == undefined || params.show == true)) {
      showDialog({
        isTopHeading: 'N',
        type: 'confirm',
        title: 'Are you sure?',
        message: 'Changes you made may not be saved.',
        okFunc: () => {
          draft_status = false;
          params.okFunc();
        },
      });
    } else {
      draft_status = false;
      params.okFunc();
    }
  });
  window.onbeforeunload = function () {
    if (draft_status) {
      return 'Changes you made may not be saved.';
    } else {
      window.onbeforeunload = null;
    }
  };

  const unsubscribe = authStore.subscribe((userState) => {
    // isLoggedIn = userState.isLoggedIn;
    if (userState != undefined) {
      if (userState.user != undefined && isMasterLoad === false) {
        isMasterLoad = true;
        loadMasterData();
      }
    }
  });
  let loadingState = false;
  const unsubscribeLoading = loadingData.subscribe((userState) => {
    loadingState = userState;
  });

  let refreshTimeout;

  const handleRefresh = async () => {
    // clear timeout if any refresh set before
    clearTimeout(refreshTimeout);
    // get expiration token in ms
    const expTokenTime = loginWillExpire();

    // function to trigger refresh token
    const triggerFetchRefresh = async () => {
      const fetchSuccess = await fetchNewToken();
      // wait success response
      if (!fetchSuccess) return null;
      // calling handle refresh recursivelly after new token injected successfully
      return handleRefresh();
    };

    // if we have expiration token and is higher than 0 we set countdown to trigger the refresh 3 min before expiration
    if (expTokenTime && expTokenTime > 0) {
      refreshTimeout = setTimeout(triggerFetchRefresh, expTokenTime);
      return null;
    }
    // if we have the token but is expired, try to refresh the token immediatelly.
    if (expTokenTime && expTokenTime < 0) return triggerFetchRefresh();
    return null;
  };

  onDestroy(() => {
    clearTimeout(refreshTimeout);
    unsubscribe();
    unsubscribeLoading();
  });

  onMount(() => {
    handleRefresh();
    authStore.subscribe((userState) => {
      isLoggedIn = userState.isLoggedIn;
      if (isLoggedIn === false) {
        if (
          window.location.pathname.includes('setup-password') ||
          ['/invalid-access', '/success'].includes(window.location.pathname)
        ) {
          publicPage = true;
        } else {
          let url = '/ui/login';
          if (window.location.href.indexOf('/redirect')) {
            url += '?redirect=' + window.location.href;
          }
          clearUser(url);
        }
      }
    });
  });

  const showDialog = (params) => {
    alertModel.show(params);
  };
  setContext('showDialog', showDialog);

  let alertModel;
  let overlayModel;
  setContext('showOverlay', (params) => {
    overlayModel.show(params);
  });
  setContext('hideOverlay', (params) => {
    overlayModel.hide(params);
  });

  import Loader from './components/Loader.svelte';
  import Test from './routes/Test.svelte';
</script>

<svelte:head>
  <style lang="scss">
    @import 'node_modules/bootstrap/scss/bootstrap.scss';

    html {
      height: 100%;
    }

    body {
      background-color: #f3f4f9;
      padding: 0px;
      margin: 0px;
      font-family: 'Poppins', sans-serif !important;

      font-size: 12px;
      font-weight: 400;
      height: 100%;
      /* needed for proper layout */
      overflow: hidden;

      &a &:hover {
        text-decoration: none;
      }

      textarea {
        resize: none;
      }
    }

    a {
      text-decoration: none;
    }

    * {
      outline: 0;
      text-decoration: none !important;
    }

    td {
      vertical-align: middle;
    }

    .right-position {
      right: 0;
    }

    .page {
      display: flex;
      flex-direction: column;
    }

    .color-blue {
      color: $blue-color;
    }

    .color-lead {
      color: $lead-color;
    }

    .page-content {
      flex: 1 1 auto;
      position: relative;
      /* need this to position inner content */
      overflow-y: auto;
    }

    button {
      font-size: 12px;
      outline: none !important;
    }

    // Form Group Start

    .form-control {
      display: block;
      width: 100%;
      padding: 0.4375rem 0.75rem;
      padding-right: 0.75rem;
      font-weight: 400;
      line-height: 1.4285714;
      color: #232e3c;
      background-color: $white-color;
      background-clip: padding-box;
      border: 1px solid $input-border-color;
      border-radius: 3px;
      transition:
        border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;
      font-size: 13px;

      &:hover {
        @include input-effect();
      }

      &:focus {
        @include input-effect();
      }

      &::placeholder {
        color: $lead-color;
      }
    }

    .error {
      .form-label {
        color: $red-color;
      }

      .form-control {
        box-shadow: 0 0 0px 1px $red-color;
        border: 1px solid $red-color !important;
        background-color: $red-light-color !important;
      }
    }

    .formError {
      background-color: $red-color;
      position: absolute;
      color: $white-color;
      font-size: 11px;
      bottom: -8px;
      right: 9px;
      padding: 0px 11px;
      border-radius: 10px;
    }

    // Form Group End
    .form-select {
      display: block;
      width: 100%;
      padding: 0.4375rem 1.75rem 0.4375rem 0.75rem;
      font-weight: 400;
      line-height: 1.4285714;
      color: #232e3c;
      background-color: #fff;
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23dadcde' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
      background-repeat: no-repeat;
      background-position: right 0.75rem center;
      background-size: 16px 12px;
      border: 1px solid #cdd9e9;
      border-radius: 3px;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      transition:
        0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;

      &:focus {
        @include input-effect();
      }
    }

    .slide-modal {
      &.modal.fade:not(.in).show .modal-dialog {
        -webkit-transform: translate3d(100%, 0, 0);
        transform: translate3d(0%, 0, 0);
      }
    }

    .slide-modal {
      &.modal.fade:not(.in) .modal-dialog {
        -webkit-transform: translate3d(100%, 0, 0);
        transform: translate3d(100%, 0, 0);
      }
    }

    .font-size-12 {
      font-size: 12px;
    }

    .font-size-13 {
      font-size: 13px;
    }

    .font-size-14 {
      font-size: 14px;
    }

    .font-size-16 {
      font-size: 16px;
    }

    .font-size-18 {
      font-size: 18px;
    }

    .font-weight-100 {
      font-weight: 100;
    }

    .font-weight-400 {
      font-weight: 400;
    }

    .font-weight-500 {
      font-weight: 500;
    }

    .font-weight-600 {
      font-weight: 600;
    }

    .background-blue {
      background-color: $blue-color;
    }

    .border-blue {
      border: 1px solid $blue-color;
    }

    .btn-add-task {
      background: white;
      color: $blue-color !important;
      border: 1px solid rgba(32, 107, 196, 0.4);

      &:hover {
        background: $blue-color !important;
        color: $white-color !important;
      }
    }

    .card-content {
      box-shadow: 0 0 30px 0 rgba(82, 63, 105, 0.05);
      border: 0;
      border-radius: 0.42rem;
    }

    .block-title {
      margin: auto;

      h3 {
        font-size: 14px;
      }
    }

    .icon-10 {
      width: 10px;
      height: 10px;
    }

    .icon-12 {
      width: 12px;
      height: 12px;
    }

    .icon-14 {
      width: 14px;
      height: 14px;
    }

    .icon-16 {
      width: 16px;
      height: 16px;
    }

    .trans-btn {
      color: #206bc4 !important;
      background: rgba(32, 107, 196, 0.04) !important;
      border-color: #90b5e2;
      outline: 0 !important;
      border-radius: 3px;

      &:focus {
        background-color: $blue-color;
        border-color: $blue-color;
        color: $white-color;
      }

      &:active {
        background-color: $blue-color;
        border-color: $blue-color;
        color: $white-color;
      }
    }

    // Data Table Start
    .table-content {
      padding: 0.5rem 1rem;

      > table {
        thead {
          th {
            color: #656d77;
            background: rgba(35, 46, 60, 0.024);
            font-size: 0.625rem;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.04em;
            line-height: 1.6;
            color: #656d77;
            padding-top: 0.5rem;
            padding-bottom: 0.5rem;
            border-bottom-color: rgba(101, 109, 119, 0.16) !important;
          }
        }
      }
    }

    // Data Table end

    .page-title {
      margin: 0;
      font-size: 1.125rem;
      line-height: 1.5555556;
      font-weight: 500;
      color: inherit;
      display: flex;
      align-items: center;
    }

    .select-border {
      border: 1px solid $input-border-color !important;
      border-radius: 3px;

      button {
        width: 100%;
        text-align: left;
        font-size: 13px;

        display: block;
        width: 100%;
        padding: 0.4375rem 0.75rem;
        padding-right: 0.75rem;
        font-weight: 400;
        line-height: 1.4285714;
        color: #232e3c;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #cdd9e9;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;

        transition:
          border-color 0.15s ease-in-out,
          box-shadow 0.15s ease-in-out;
      }
    }

    .add-btn-col {
      max-width: 45px !important;
    }

    .input-date-picker {
      border: 1px solid $input-border-color;
    }

    .background-blue {
      background-color: $blue-color;
    }

    .file-attachment {
      border: 3px dashed $input-border-color;
      padding: 6px;

      border: 2px dashed #206bc4;
      padding: 6px;
      background-color: #fff;
      padding: 15px;
      border-radius: 4px;
    }

    .select-block {
      > button {
        padding: 8px 8px;
      }

      button {
        font-size: 12px;
      }

      &.active {
        .dropdown-toggle {
          background: rgba(205, 217, 233, 0.4) !important;
        }
      }
    }

    .btn-close {
      box-sizing: content-box;
      width: 0.75rem;
      height: 0.75rem;
      padding: 0.25em 0.25em;
      color: inherit;
      background: url(/images/cancel.svg);
      border: 0;
      border-radius: 3px;
      opacity: 0.3;
      background-size: 14px;
      background-repeat: no-repeat;
      background-position: center;

      &:active {
        box-shadow: none;
        background-color: transparent;
      }

      &:focus {
        box-shadow: none;
        background-color: transparent;
      }

      &:not(:disabled):active {
        background-color: transparent;
      }
    }

    .modal.fade .modal-dialog {
      transition:
        opacity 0.3s linear,
        right 0.3s ease-out;
      -webkit-transition:
        opacity 0.3s linear,
        right 0.3s ease-out;
      -moz-transition:
        opacity 0.3s linear,
        right 0.3s ease-out;
      -o-transition:
        opacity 0.3s linear,
        right 0.3s ease-out;
    }

    .filter-block-content {
      border-bottom: 1px solid rgba(0, 0, 0, 0.125);
      padding: 0.5rem 1rem;
    }

    .top-menu-filter {
      border-bottom: 1px solid #cdd9e9;
      padding: 0.5rem 1rem;
    }

    .add-task-modal {
      transition: transform 650ms ease !important;

      &.modal-dialog {
        max-width: 850px;
        opacity: 1;
        pointer-events: auto;
        width: 100%;
      }

      .page-content {
        overflow-x: hidden;
      }

      .modal-content {
        height: 100%;
        border: 0px solid rgba(0, 0, 0, 0.2);
      }

      .modal-body {
        padding: 0px;
      }

      .modal-title {
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.3333333;
      }

      .modal-header {
        background-color: #fbfbfb;
      }
    }

    .button-group svg {
      width: 18px;
      height: 18px;
      fill: var(--dimgray-color);
      margin-right: 9px;
    }

    .button-group:hover svg,
    .button-group:focus svg {
      fill: $white-color;
    }

    .common-btn-group {
      background: rgba(32, 107, 196, 0.1);
      padding: 3px;
      border-radius: 4px;
      max-width: 600px;
      position: relative;
      z-index: 1;

      .btn-primary {
        &:not(:disabled) {
          &:active {
            background-color: white;
            color: $blue-color;
          }
        }
      }

      a {
        color: $black-color !important;
        white-space: nowrap;
        padding: 5px 20px;
      }

      button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: #232e3c;
        background-color: transparent;
        border-color: rgba(101, 109, 119, 0.24);
        white-space: nowrap;
        font-size: 12px;
        border: 0px;

        &:hover {
          background-color: $white-color;
          border: 0;
          color: $blue-color !important;
          border-radius: 4px;

          svg {
            fill: $blue-color;
          }
        }

        &:focus {
          background-color: $white-color;
          border-color: $white-color;
          border-radius: 4px;

          svg {
            fill: $blue-color;
          }
        }
      }

      .active {
        background-color: $white-color;
        color: $blue-color !important;

        svg {
          fill: $blue-color;
        }

        &:hover {
          color: $blue-color !important;

          svg {
            fill: $blue-color;
          }
        }
      }
    }

    .bg-badge-red {
      @include red-badge();
      padding: 2px 9px;
      border-radius: 20px;
      font-weight: 400;
    }

    .bg-badge-green {
      @include green-badge();
      padding: 2px 9px;
      border-radius: 20px;
      font-weight: 400;
    }

    .neg-value {
      @include red-badge();
    }

    .btn-view-type {
      button {
        border-radius: 4px;
        transition: all 0.2s ease-in-out;

        &:hover {
          background: rgba(32, 107, 196, 0.1);
        }

        &.active {
          background: rgba(32, 107, 196, 0.1);

          svg {
            fill: $blue-color;
          }
        }
      }
    }

    .btn-list-view {
      svg {
        width: 17px;
        height: 17px;
        fill: #656d77;
      }
    }

    .calendar-area {
      .flatpickr-calendar {
        width: 100%;
        box-shadow: none;
      }

      .flatpickr-monthDropdown-months {
        @include flatpickr-month();
      }

      .numInput {
        @include numInput();
      }

      .flatpickr-next-month {
        &:hover {
          svg {
            fill: $blue-color;
          }
        }
      }

      .flatpickr-prev-month {
        &:hover {
          svg {
            fill: $blue-color;
          }
        }
      }

      .flatpickr-rContainer {
        margin: auto;
      }
    }

    .select-calendar {
      .flatpickr-monthDropdown-months {
        @include flatpickr-month();
      }
    }

    .add-task-btn {
      white-space: nowrap;
      background-color: $blue-color !important;
      color: $white-color;
      border-color: $blue-color;
      border-radius: 4px;
      padding-top: 3px;
      padding-bottom: 3px;

      &:not(:disabled):active {
        background-color: $blue-color;
      }

      &:focus {
        background-color: $blue-color;
      }

      img {
        width: 13px;
        height: 13px;
      }
    }

    @mixin menu-hover-animation {
      backface-visibility: hidden;
      transform: scaleX(0);
      border-color: #fff;
      transition:
        transform 0.3s ease-out,
        border-color 0.3s ease-out;
      position: absolute;
      display: block;
      bottom: -6px;
      left: 0;
      width: 100%;
      border-top: 2px solid #fff;
      content: '';
      padding-bottom: inherit;
    }

    .nav-item {
      > button {
        color: #fff;

        &:hover {
          span {
            &::before {
              transform: scaleX(1);
              content: ' ';
            }
          }
        }

        span {
          position: relative;

          &:before {
            @include menu-hover-animation();
          }
        }

        &.active {
          span {
            &:before {
              @include menu-hover-animation();
              transform: scaleX(1);
            }
          }
        }
      }
    }

    .fill-white {
      fill: $white-color;
    }

    .settings-left-nav {
      background: rgba($input-border-color, 0.3);
      border-radius: 6px 0 0 6px;
      flex: 0 0 280px;
      width: 280px;

      ul {
        padding: 0px;
        list-style: none;

        li {
          a {
            color: $lead-color;
            padding: 10px 3px;
            display: block;
          }
        }
      }
    }

    .form-slect-comp {
      padding: 0.5rem 1rem;
    }

    .modal-form-area {
      padding: 0.5rem 1rem;
    }

    .input-block-search {
      // .tagify__input
      // {
      //   padding-top:0px;
      //   padding-bottom:0px;
      //   position: absolute;
      //   right:0px;
      // }
      // .tagify--outside
      // {
      //   min-width: 160px;
      //   transition: width 0.5s;
      //   white-space: nowrap;
      //   width: auto;
      //   padding-right: 200px !important;
      //   height:31px;

      // }
      .tagify__tag {
        margin-top: 2px;

        > div {
          padding: 1px 5px;
        }
      }

      .tagify__input {
        padding-top: 3px;
        padding-bottom: 0;
        min-width: 240px;
        line-height: 13px;
        min-height: 19px;
        margin-left: 0px;
      }

      input[type='text'] {
        width: 240px;
        padding: 6px 28px 5px 6px !important;
        transition: width 0.5s;
        right: 0px;

        &:focus {
          width: 370px;
        }
      }

      img {
        position: absolute;
        z-index: 1;
        font-size: 18px;
        top: 8px;
        right: 5px;
        width: 16px;
      }
    }

    .color-red {
      color: $red-color;
    }

    button {
      &.color-red {
        &:hover {
          color: $red-color;
        }
      }
    }

    .nav-item {
      .nav-items-link {
        padding: 24px 0px;

        svg {
          fill: #fff;
          margin-right: 4px;
        }
      }

      .nav-items-button {
        padding: 22px 15px;
      }
    }

    .profile-content {
      .title {
        border-bottom: 1px solid $input-border-color;
        padding-bottom: 10px;
        margin-top: 11px !important;

        span {
          border-bottom: 2px solid $blue-color;
          padding-bottom: 7px;
          padding-right: 10px;
        }
      }

      .nav-pills {
        .nav-item {
          .error {
            background-color: rgba($red-color, 0.2) !important;
            color: $red-color !important;
          }
        }
      }
    }

    .popover {
      border: 0px;
      box-shadow: 0 0 30px 0 rgba(82, 63, 105, 0.05);
    }

    .dropdown {
      .dropdown-item {
        &:active {
          background-color: #f8f9fa;
        }
      }

      > button {
        transition: 0.03s;

        &:not(:disabled):active {
          background: rgba($input-border-color, 0.4);
        }

        &:hover {
          background: rgba($input-border-color, 0.4) !important;
        }

        &.show {
          background: rgba($input-border-color, 0.4) !important;
        }

        &.dropdown-toggle {
          transition: background-color 0.2s ease-in-out;

          &.active {
            // background: rgba($input-border-color, 0.4);
          }
        }
      }

      .dropdown-menu {
        box-shadow:
          0 0 0 1px rgba(111, 119, 130, 0.15),
          0 5px 20px 0 rgba(21, 27, 38, 0.08);
        display: block;
        visibility: hidden;
        opacity: 0;
        transform: translateY(50px);
        transition: 0.5s ease all;
        border: 0px;

        a {
          color: $black-color;
        }

        &.show {
          display: block;
          visibility: visible;
          opacity: 1;
          transform: translateY(0px);
          transition: 0.5s ease all;
        }
      }

      .dropdown-action-link {
        color: $blue-color !important;
      }
    }

    .color-black {
      color: $black-color;
    }

    .fields-block {
      border: 1px solid $input-border-color;

      .title-fields {
        background-color: $white-color;
        top: -9px;
        background: white;
        left: 5px;
      }

      .radio-block-btn {
        height: 37px;
      }

      .trash-icon-btn {
        right: 12px;
        top: -18px;
      }
    }

    .box-block {
      border: 1px solid $input-border-color;
      background: $light-blue-color;
    }

    .multiSelectItem {
      &:hover {
        background-color: $blue-color !important;
      }
    }

    .btn-primary {
      &:active {
        background-color: $blue-color;
        box-shadow: none;
      }

      &:focus {
        box-shadow: none;
      }

      &:not(:disabled):active {
        background-color: $blue-color;
        box-shadow: none;
      }
    }

    .btn-link {
      &:foucs {
        box-shadow: none;
        border: 0px;
        background-color: transparent;
      }

      &:active {
        box-shadow: none;
        border: 0px;
        background-color: transparent;
      }
    }

    .left-nav-bar {
      .nav-link {
        transition: none !important;
      }
    }

    .calendar-area {
      .flatpickr-day {
        font-size: 12px;
      }
    }

    .dropdown-item {
      color: $lead-color;

      &:active {
        background-color: #f8f9fa;
        color: $lead-color;
      }
    }

    .calendar-input-block {
      max-width: 145px;
    }

    .calendar-initial-board {
      max-width: 170px;
    }

    .update-calendar {
      max-width: 150px;
    }

    .right-action-btn {
      .btn-export {
        margin-top: -1px;

        svg {
          width: 14px;
          height: 14px;
          fill: #656d77;
        }
      }
    }

    .form-group {
      &.select-block {
        .selectContainer {
          height: 34px;
          border-color: $input-border-color;
          font-size: 13px;
          font-weight: 400;

          .clearSelect {
            height: 18px;
            top: 7px;
          }

          .indicator {
            svg {
              position: relative;
              top: -5px;
            }
          }
        }
      }
    }

    .select-client-type {
      .multiSelectItem {
        margin-top: 3px;
        margin-bottom: 3px;
      }

      .selectContainer {
        min-width: 190px;
      }

      &.business-template {
        max-width: 210px;
      }

      &.business-activity-template {
        max-width: 210px;
        min-width: 190px;
      }
    }

    .assignee-select {
      svg {
        width: 16px;
        height: 16px;
        position: absolute;
        fill: #787e8d;
        left: 0px;
        z-index: 1;
        top: 10px;
        left: 12px;
      }

      input {
        padding-left: 34px !important;
        font-size: 13px !important;
        font-weight: 400 !important;
      }

      .selection {
        padding-left: 20px !important;
      }

      .clearSelect {
        height: 18px;
        top: 0 !important;
        right: 13px !important;
      }
    }

    .selectContainer {
      border-color: $input-border-color !important;

      input {
        font-size: 13px !important;
      }

      &.focused {
        border-color: $blue-color !important;
        box-shadow: 0 0 0px 1px $blue-color;
      }

      &:hover {
        border-color: $blue-color !important;
        box-shadow: 0 0 0px 1px $blue-color;
      }
    }

    hr {
      background-color: $input-border-color;
    }

    .add-client-btn {
      padding-top: 8px;
      padding-bottom: 8px;
    }

    .form-inactive {
      .selectContainer {
        padding-right: 0px !important;
      }

      .selectedItem {
        padding-right: 0px !important;
      }

      .selectContainer {
        border-color: $white-color !important;

        input {
          padding-left: 0px !important;
        }

        &:hover {
          box-shadow: none;
        }

        &:focus {
          border-color: $white-color !important;
        }
      }

      .select-border {
        border-color: $white-color;
      }

      .calendar-input {
        border: 1px solid #fff !important;
      }

      &.form-control:disabled {
        background-color: transparent !important;
        opacity: 10 !important;
        color: $lead-color !important;
      }

      .form-control[readonly] {
        background-color: transparent !important;
        opacity: 10 !important;
        color: $lead-color !important;
      }

      .selectContainer {
        background-color: transparent !important;
        padding-left: 0px !important;

        .indicator {
          display: none;
        }
      }
    }

    table {
      tr {
        td {
          border-bottom: 1px solid $input-border-color;
          padding-top: 4px;
          padding-bottom: 4px;
        }
      }
    }

    .error-block {
      min-height: 25px;
    }

    .full-calendar {
      .fc {
        .fc-button-primary {
          &:focus {
            box-shadow: none;
          }
        }
      }

      .fc-toolbar-title {
        font-size: 15px;
      }

      .fc-theme-standard {
        border-color: $lead-color;
      }

      th {
        font-weight: 500;
      }

      .fc-header-toolbar {
        margin-bottom: 10px !important;
      }

      .fc-today-button {
        background-color: transparent !important;
        border: 0px !important;
        color: $blue-color !important;
      }

      .fc-button {
        background-color: transparent !important;
        border: 0px !important;
        color: $blue-color !important;
      }
    }

    .btn-add-client {
      button {
        &.show {
          background-color: $blue-color !important;
        }
      }
    }

    .flatpickr-monthDropdown-months {
      @include flatpickr-month();
    }

    .numInput {
      @include numInput();
    }

    .c-checkbox input[type='checkbox']:checked + span {
      background-image: url('/images/check.svg');
      background-size: 12px 12px;
      background-repeat: no-repeat;
      background-position: center center;
    }

    input[type='radio']:checked + span {
      background-image: url('/images/check-blue.svg');
      background-size: 12px 12px;
      background-repeat: no-repeat;
      background-position: center center;
    }

    .input-icon {
      img {
        left: 13px;
        top: 35px;
      }

      input {
        padding-left: 40px;
      }
    }

    .btn-select-client {
      width: 100%;

      &:hover {
        color: #1e2125;
        background-color: #f8f9fa !important;
      }
    }

    .status-switch-block {
      input {
        width: 52px !important;
        height: 26px;
      }
    }

    .btn-save {
      min-width: 96px;
    }

    .filter-input-date-picker {
      max-width: 135px;
      height: 30px;

      img {
        top: 10px !important;
      }
    }

    .flatpickr-day {
      &:hover {
        background-color: $blue-color;
        color: $white-color;
      }

      &.selected {
        background-color: $blue-color;
      }
    }

    .cursor {
      cursor: pointer;
    }

    .activity-filter-block {
      .calendar-input {
        height: 29px;

        input {
          padding-top: 4px;
        }

        .img-calendar {
          top: 5px !important;
        }
      }
    }

    .repeats-block-content {
      svg {
        margin-top: -7px;
      }
    }

    .search-client-input {
      input {
        padding-right: 20px;
      }

      img {
        right: 13px;
        top: 7px;
      }
    }

    .top-header-menu {
      animation-name: slideIn;
      animation-fill-mode: both;
      animation-duration: 0.3s;
    }

    .shake-column {
      animation-name: shakeColumn;
      animation-fill-mode: both;
      animation-duration: 3s;
    }

    @-webkit-keyframes shakeColumn {
      50% {
        background-color: #ffe5b4;
      }
    }

    @-webkit-keyframes slideIn {
      to {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
      }

      0% {
        -webkit-transform: translateY(1rem);
        transform: translateY(1rem);
        opacity: 0;
      }
    }

    @keyframes slideIn {
      to {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
      }

      0% {
        -webkit-transform: translateY(1rem);
        transform: translateY(1rem);
        opacity: 0;
      }
    }

    .trash-icon {
      margin-top: -4px;
    }

    .dropdown-company {
      .dropdown-menu {
        margin-top: 12px !important;

        &:before {
          display: inline-block;
          content: '';
          position: absolute;
          top: -10px;
          left: 12px;
          border-right: 10px solid transparent;
          border-bottom: 10px solid #fff;
          border-left: 10px solid transparent;
          z-index: 1;
        }

        &:after {
          display: inline-block;
          content: '';
          position: absolute;
          top: -10px;
          left: 12px;
          border-right: 10px solid transparent;
          border-bottom: 10px solid #999;
          border-left: 10px solid transparent;
        }
      }

      .dropdown-toggle {
        &:after {
          background-image: url(/images/down-arrow-white.svg);
        }
      }
    }

    .form-inactive {
      border-color: #fff !important;
      padding-left: 0px;

      &::placeholder {
        color: #787e8d !important;
      }

      .selectContainer {
        .selection {
          color: #787e8d !important;
        }
      }

      &:hover {
        border-color: #fff;
        box-shadow: none;
      }

      &:focus {
        border-color: #fff;
        box-shadow: none;
      }

      .selection {
        color: #787e8d !important;
      }
    }

    .task-manager-row {
      background-color: #f6ebdf;
    }

    .request-review-row {
      background-color: #e8eff7;
    }

    .overdue-row {
      color: $red-color;
    }

    .overdue-row {
      td,
      button.color-blue,
      button span,
      button.taskdate {
        color: $red-color !important;
      }
    }

    .task-outlook-grid .tabulator-row.overdue-row .tabulator-cell {
      color: $red-color !important;
    }

    .collabrator-row {
      background-color: #e2efff;
    }

    .status-pill {
      span {
        padding: 8px 9px;
        border-radius: 5px;
        display: block;
        text-align: center;
        color: #fff;
      }
      &.blackText {
        span {
          color: #000;
        }
      }
    }

    $orangeStatus: #f1a983;

    $statusColor: (
      1: $orangeStatus,
      2: #1bc16e,
      3: #adadad,
      4: $orangeStatus,
      5: $orangeStatus,
      6: $orangeStatus,
      7: $orangeStatus,
      8: $orangeStatus,
      9: $orangeStatus,
      10: $orangeStatus,
      11: $orangeStatus,
      12: $orangeStatus,
      13: $orangeStatus,
      14: #0e769e,
    );

    @each $key, $val in $statusColor {
      .td-status-#{$key} {
        background-color: #{$val};
        button,
        span,
        button.active {
          font-size: 12px;
          width: 100%;
          background: none !important;
        }
        button:hover {
          background-color: #{$val} !important;
        }
      }
    }

    /* Compliance statuses color palette */
    $complianceColor: (
      1: #d0d0d0,
      2: #8d8989,
      3: #9f87ce,
      4: #50bfe1,
      5: #ffa962,
      6: #fc7988,
      7: #53c4b1,
    );
    @each $key, $val in $complianceColor {
      .td-compliance-#{$key} {
        background-color: #{$val};
        button,
        span,
        button.active {
          font-size: 12px;
          width: 100%;
          background: none !important;
        }
        button:hover {
          background-color: #{$val} !important;
        }
      }
    }

    /* Low and medium color */
    $riskRankLowMedium: #cdd9e966;

    /* Risk rank color palette */
    $riskRankColorsOutlook: (
      1: $riskRankLowMedium,
      2: $riskRankLowMedium,
      3: #a03064,
    );
    @each $key, $val in $riskRankColorsOutlook {
      .td-risk-rank-#{$key} {
        background-color: #{$val};
        button,
        span,
        button.active {
          font-size: 12px;
          width: 100%;
          background: none !important;
        }
        button:hover {
          background-color: #{$val} !important;
        }
      }
    }

    .priority-dropdown.me-1,
    .risk-rank-dropdown.me-1 {
      margin-right: 0 !important;
    }

    .priority-dropdown .dropdown-toggle::after,
    .risk-rank-dropdown .dropdown-toggle::after {
      top: -2px;
    }

    .dropdown-toggle::after {
      background-image: url(/images/down-arrow.svg);
      background-size: 11px 9px;
      width: 13px;
      height: 11px;
      background-repeat: no-repeat;
      border: 0px !important;
      background-position: 0px 4px;
      top: 2px;
      position: relative;
    }

    .dropdown-toggle-view::after {
      background-image: url(/images/view-icon.svg) !important;
      width: 15px;
      height: 15px;
      background-size: 100%;
      top: -3px;
    }

    .btn-add-client {
      &.dropdown {
        button:not(:disabled):active {
          background: $blue-color;
        }
      }
    }

    .showDropDown {
      background: rgba(205, 217, 233, 0.4);

      &::after {
        background-image: url(/images/down-arrow-up.svg);
      }
    }

    .login-bg {
      background-size: cover;
      background-color: white;

      .card {
        box-shadow: 0px 0px 30px rgba(62, 14, 136, 0.12) !important;
        border: 0px !important;
      }
    }

    .tabs-block {
      background-color: $silver-color;
      margin-left: -15px;
      margin-right: -16px;

      .tabber-btn {
        background-color: $silver-color;
        border: 1px solid $silver-color;
        padding: 6px 20px;

        &.active {
          background-color: $blue-color;
          color: $white-color;
          border: 1px solid $blue-color;

          svg {
            fill: $white-color;
          }
        }

        svg {
          width: 16px;
          height: 16px;
          margin-right: 6px;
        }
      }

      .tabs-area {
        border: 1px solid $input-border-color;
        border-radius: 3px;
        box-shadow: 0 0 30px 0 rgba(82, 63, 105, 0.05);
      }

      .tabs-content-area {
        padding: 1rem 1rem;
        border-radius: 3px;

        .btn-group {
          margin-bottom: 1rem;
        }

        .add-btn {
          color: $blue-color;
          margin-top: 33px;
        }

        .remove-btn {
          margin-top: 33px;
          color: $red-color;
        }
      }
    }

    .header-tab-btn {
      .active {
        position: relative;
        color: $blue-color;

        &:before {
          content: '';
          background-color: #206bc4;
          color: #206bc4 !important;
          position: absolute;
          width: 100%;
          height: 2px;
          bottom: 0;
          left: 0;
        }
      }
    }

    .btn-link {
      &:disabled {
        img {
          -webkit-filter: grayscale(100%);
          filter: grayscale(100%);
        }
      }
    }

    .client-tab-header {
      svg {
        margin-right: 6px;
      }

      .active {
        position: relative;
        color: $blue-color;

        &:before {
          content: '';
          background-color: $blue-color;
          position: absolute;
          bottom: -2px;
          height: 2px;
          width: 100%;
          color: $blue-color !important;
        }

        svg {
          fill: $blue-color !important;
        }
      }
    }

    .sub-type-block {
      input {
        height: 32px !important;
      }
    }

    .loader-block {
      color: $blue-color;
      width: 22px !important;
      height: 22px !important;
    }

    .recuring-every-input {
      width: 90px !important;
    }

    .calendar-content-area {
      flex: 0 0 180px;
      max-width: 180px;
    }

    .tagify.customLook {
      border-radius: 4px;
      border: 1px solid #cdd9e9;
    }

    .tagify__tag > div::before {
      box-shadow: 0 0 0 1.1em rgba(205, 217, 233, 0.6) inset !important;
    }

    .tagify__tag {
      margin: 4px 0 1px 5px;
    }

    .overlayModal {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
    }

    .activity-log-input {
      height: 35px;
    }

    .client-reg-subtype {
      .multiSelectItem {
        margin-top: 3px !important;
        margin-bottom: 3px !important;
      }
    }

    .input-subtask.error .sub-task-input {
      border-bottom: 2px solid red !important;
    }

    @media (min-width: 1300px) and (max-width: 1600px) {
      .tasklist-popover {
        > img {
          position: relative;
          left: 7px;
        }
      }

      .tab-pane {
        .dropdown {
          &.select-box-dropdown {
            > button {
              padding: 7px 20px 7px 12px !important;
            }
          }
        }
      }

      .task-outlook-content {
        width: calc(100vw - 50px);

        .accordion-body {
          overflow: auto;
        }
      }

      .top-menu-filter {
        .left-action-bar {
          .bulk-action-drop {
            margin-right: 40px !important;
          }
        }
      }

      .left-action-bar {
        .bulk-action-drop {
          margin-right: 40px;
        }

        .filters {
          label {
            display: flex;
            flex-direction: row;
            line-height: 13px;
            align-items: center;
          }

          .check-img {
            flex: 0 0 20px;
            max-width: 20px;
          }
        }

        .reset-filter {
          line-height: 13px;
        }

        .dropdown {
          margin-right: 3px !important;
        }
      }

      .right-action-content {
        flex: 0 0 170px !important;
        min-width: 170px !important;
      }

      .nav-item {
        text-align: center;

        .nav-items-link {
          padding-left: 8px !important;
          padding-right: 8px !important;
        }
      }

      .tasklist-content {
        & > div {
          width: calc(100vw - 90px);
          // overflow: auto;
        }
      }

      .dropdown > button.dropdown-toggle {
        padding-left: 4px !important;
        padding-right: 4px !important;
      }
    }

    .tagify {
      .tagify__dropdown {
        border-color: $blue-color;
      }

      &.tagify--focus {
        border-color: $blue-color;
        box-shadow: 0 0 0px 1px $blue-color;
      }
    }

    .flatpickr-day.selected,
    .flatpickr-day.startRange,
    .flatpickr-day.endRange,
    .flatpickr-day.selected.inRange,
    .flatpickr-day.startRange.inRange,
    .flatpickr-day.endRange.inRange,
    .flatpickr-day.selected:focus,
    .flatpickr-day.startRange:focus,
    .flatpickr-day.endRange:focus,
    .flatpickr-day.selected:hover,
    .flatpickr-day.startRange:hover,
    .flatpickr-day.endRange:hover,
    .flatpickr-day.selected.prevMonthDay,
    .flatpickr-day.startRange.prevMonthDay,
    .flatpickr-day.endRange.prevMonthDay,
    .flatpickr-day.selected.nextMonthDay,
    .flatpickr-day.startRange.nextMonthDay,
    .flatpickr-day.endRange.nextMonthDay {
      background: $blue-color;
      -webkit-box-shadow: none;
      box-shadow: none;
      border-color: $blue-color;
    }

    .flatpickr-day.inRange {
      border-radius: 0;
      -webkit-box-shadow:
        -5px 0 0 #c2dcfa,
        5px 0 0 #c2dcfa;
      box-shadow:
        -5px 0 0 #c2dcfa,
        5px 0 0 #c2dcfa;
    }

    .flatpickr-day.inRange {
      background: #c2dcfa;
      border-color: #c2dcfa;
    }

    .flatpickr-day.inRange,
    .flatpickr-day.prevMonthDay.inRange,
    .flatpickr-day.nextMonthDay.inRange,
    .flatpickr-day.today.inRange,
    .flatpickr-day.prevMonthDay.today.inRange,
    .flatpickr-day.nextMonthDay.today.inRange,
    .flatpickr-day:hover,
    .flatpickr-day.prevMonthDay:hover,
    .flatpickr-day.nextMonthDay:hover,
    .flatpickr-day:focus,
    .flatpickr-day.prevMonthDay:focus,
    .flatpickr-day.nextMonthDay:focus {
      background: #c2dcfa;
      border-color: #c2dcfa;
    }

    .flatpickr-day.nextMonthDay.inRange {
      background: #c2dcfa;
      border-color: #c2dcfa;
    }

    .flatpickr-day.nextMonthDay.selected.startRange.inRange {
      background: $blue-color;
      border-color: $blue-color;
    }

    .flatpickr-day.nextMonthDay.selected.endRange.inRange {
      background: $blue-color;
      border-color: $blue-color;
    }

    .mail-message {
      height: 320px;
    }

    .modal-body-height {
      max-height: calc(100vh - 160px);
      overflow: auto;
    }

    .task-type-block {
      width: 155px;

      .selectContainer {
        min-width: 100%;
      }
    }

    .fc-h-event {
      border: 1px solid $input-border-color;
      padding-left: 3px;
      padding-right: 3px;
      background-color: #e5effc !important;
    }

    .assignee-filter-drop {
      margin-right: 0px !important;
      margin-left: 0px;

      .active {
        border-radius: 4px 0 0 4px;
      }
    }

    .bulk-action-drop {
      min-width: 77px;
      margin-right: 40px !important;
    }

    .projects-block {
      .title {
        width: 60px;
        text-overflow: ellipsis;
        overflow: hidden;
        display: inline-block;
        vertical-align: middle;
        line-height: 14px;
      }
    }

    .assign-task-dropdown {
      .title {
        max-width: 140px;
        text-overflow: ellipsis;
        overflow: hidden;
        display: inline-block;
        vertical-align: middle;
      }
    }

    .fc .fc-button-primary:not(:disabled):active:focus,
    .fc .fc-button-primary:not(:disabled).fc-button-active:focus {
      box-shadow: none;
    }

    .fc-button-group {
      background: rgba(205, 217, 233, 0.4) !important;
      border-radius: 6px;

      .fc-button-active {
        background: $blue-color !important;
        color: $white-color !important;
      }
    }

    .user-name {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 200px;
    }

    .task-log {
      ul {
        margin: 0px;
        padding: 0px;
        list-style: none;

        li {
          padding-bottom: 20px;
          padding-top: 4px;

          &:before {
            width: 2px;
            content: '';
            background-color: rgba($lead-color, 0.4);
            position: absolute;
            left: 0px;
            top: 7px;
            height: 100%;
            left: 18px;
          }

          &:last-child {
            &:before {
              display: none;
            }
          }

          .user-log-icon {
            width: 30px;
            height: 30px;
            background-color: #206bc4;
            left: 0px;
            top: 0px;
            border-radius: 30px;

            img {
              width: 15px;
              height: 15px;
            }
          }
        }
      }

      .comment-block {
        color: $lead-color;
      }
    }

    .listContainer {
      .item {
        &.active {
          background: $blue-color;
        }
      }
    }

    .due-date-heading {
      flex: 0 0 100px;
      max-width: 100px;
    }

    .comments-tag-input {
      .tagify__input {
        word-wrap: break-word !important;
        word-break: break-word !important;
      }
    }

    .comments-tag-input .tagify__input .tagify__tag > div {
      padding-top: 2px;
    }

    .comments-tag-input .tagify__tag {
      align-items: flex-start;
    }

    .popover {
      z-index: 500000000 !important;
      font-size: 12px;
    }

    .column-unit-name {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      display: inline-block;
      vertical-align: top;
    }

    .select-box-dropdown {
      > button {
        border: 1px solid #cdd9e9 !important;
        padding: 7px 8px 7px 12px !important;
        min-width: 100px;
        text-align: left;
        position: relative;

        &:hover {
          box-shadow: 0 0 0px 1px $blue-color !important;
          border: 1px solid $blue-color !important;
          background-color: transparent !important;
        }

        &:focus {
          box-shadow: 0 0 0px 1px $blue-color !important;
          border: 1px solid $blue-color !important;
          background-color: transparent !important;
        }
      }

      &.active {
        .dropdown-toggle {
          background-color: transparent !important;
        }
      }

      .dropdown-toggle {
        padding-right: 20px !important;

        &:after {
          position: absolute;
          right: 4px;
          top: 8px;
        }
      }
    }

    .sub-task-count {
      top: 1px;
    }

    .select-date-format {
      .selectContainer {
        > div {
          top: auto !important;
          bottom: 39px;
        }
      }

      .indicator {
        top: 12px !important;
      }
    }

    .profile-content {
      .select-date-format {
        .indicator {
          top: 12px !important;
        }

        .clearSelect {
          top: 8px !important;
        }
      }
    }

    button.color-blue {
      &:hover {
        color: $blue-hover-color;
      }
    }

    .close-button {
      background-color: #52616f !important;
      width: 16px !important;
      height: 16px !important;
      border-radius: 50% !important;
      line-height: 0px;
      padding: 0px;
      z-index: 1;

      img {
        width: 8px;
      }
    }

    .tagify__tag-text {
      font-size: 12px;
      line-height: 15px;
    }

    .tagify__tag__removeBtn {
      &:after {
        height: 11px;
      }
    }

    .input-outlook-search .tagify__tag__removeBtn {
      &:after {
        height: 17px;
      }
    }

    .task-button-applicable {
      margin-left: 12px;
    }

    textarea.form-control:disabled,
    textarea.form-control[readonly] {
      color: #ccc;
    }

    .btn-drag {
      max-height: 13px;
      opacity: 0.6;
      cursor: move;
    }

    .subtask-list-item {
      &.is-active {
        cursor: move;
        background-color: $input-border-color !important;

        input {
          background-color: $input-border-color;
        }

        .btn-drag {
          opacity: 0.9;
          cursor: pointer;
        }
      }
    }

    .add-task-input {
      @extend .subtask-list-item;
    }

    .tagify__input[data-placeholder] {
      &::before {
        color: $lead-color;
      }
    }

    .error-message {
      min-height: 37px;
    }

    .password-notes {
      font-size: 11px;
      color: #787e8d;
      position: relative;
      top: -12px;
      text-align: right;
      width: 100%;
      color: $lead-color;
    }

    .code-password-input {
      padding-right: 100px;
    }

    .flatpickr-months {
      .flatpickr-prev-month {
        &:hover {
          svg {
            fill: $blue-color;
          }
        }
      }

      .flatpickr-next-month {
        @extend .flatpickr-prev-month;
      }
    }

    .flatpickr-day {
      border-radius: 0px;

      &:hover {
        background-color: $input-border-color;
        color: $black-color;
        border-color: $input-border-color;
      }

      &.startRange {
        &.startRange {
          border-radius: 0px;
        }
      }

      &.inRange {
        &:hover {
          color: #000;
          background-color: $silver-color;
          box-shadow:
            -5px 0 0 $silver-color,
            5px 0 0 $silver-color;
        }
      }

      &.selected {
        &.startRange {
          border-radius: 0px;
        }
      }

      &.endRange {
        &.endRange {
          border-radius: 0px;
        }
      }

      &.inRange {
        background: #f5f5f5;
        border-color: #f5f5f5;
        box-shadow:
          -5px 0 0 #f5f5f5,
          5px 0 0 #f5f5f5;
      }
    }

    .flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n + 1)),
    .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n + 1)),
    .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n + 1)) {
      box-shadow: -10px 0 0 #f5f5f5;
    }

    span.flatpickr-weekday {
      font-weight: 400;
    }

    .flatpickr-current-month span.cur-month {
      font-weight: 500;
      font-size: 14px;
    }

    .flatpickr-day {
      height: 33px;
      line-height: 33px;
    }

    .rangeMode .flatpickr-day {
      margin-top: 0px !important;
    }

    .flatpickr-day.inRange {
    }

    .flatpickr-calendar.multiMonth
      .flatpickr-days
      .dayContainer:nth-child(n + 2)
      .flatpickr-day.inRange:nth-child(7n + 1) {
      box-shadow:
        0px 0 0 #e6e6e6,
        5px 0 0 #e6e6e6;
    }

    .dayContainer + .dayContainer {
      box-shadow: 0px 0 0 #e6e6e6;
    }

    .flatpickr-calendar.animate.open {
      padding: 6px 0px 4px 2px;
    }

    .flatpickr-day.inRange:hover {
      box-shadow:
        0px 0 0 rgb(32 107 196 / 10%),
        5px 0 0 rgb(32 107 196 / 10%);
    }

    .ul-list {
      list-style: none;
      padding: 0px;
      margin: 0px;

      li {
        display: inline-block;
        margin-right: 8px;
        padding: 6px 27px 6px 9px;
        border-radius: 17px;
        position: relative;
        margin-bottom: 6px;

        &.active {
          background-color: #ebedef;
        }

        &.inactive {
          background-color: #e9ecef;
          color: #ccc;

          button {
            background-color: #d8dbdf !important;
          }
        }
      }

      .close-button {
        position: absolute;
        right: 6px;
      }
    }

    .filepond--credits {
      display: none;
    }

    .file-upload-attachment {
      background-image: url(/images/file-upload.svg);
      background-size: 39px;
      background-repeat: no-repeat;
      height: 67px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-position: center left;
      padding-left: 50px;
      cursor: pointer;
    }

    .user-profile-img-block {
      .file-upload-attachment {
        background: transparent;
        padding-left: 0px;
      }

      .filepond--panel-root {
        background-color: transparent !important;
      }

      .file-upload-attachment {
        line-height: 15px;
      }

      .filepond--root .filepond--list-scroller {
        margin: 2px !important;
      }

      .filepond--image-preview-overlay-idle {
        color: transparent !important;
      }

      .filepond--file {
        padding: 0px !important;
      }

      .filepond--image-preview-wrapper {
        border-radius: 0px !important;
      }

      .filepond--root .filepond--drop-label {
        width: 120px !important;
      }

      .filepond--list {
        left: 0 !important;
        right: 0 !important;
      }
    }

    .add-subtask {
      font-size: 13px;
    }

    .modal {
      z-index: 10000;
    }

    .fc-more-popover {
      position: fixed !important;
    }

    .tagify__dropdown {
      z-index: 1000000 !important;
    }

    .funds-section {
      .accordion-flush-items {
        &:last-child {
          .accordion-item {
            margin-bottom: 0px !important;
          }
        }
      }
    }

    .header-user-profile {
      .userProfileImg {
        div {
          border: 1px solid #fff;
        }
      }
    }

    .overdue-calendar-row .fc-event-title {
      color: #f7524f !important;
    }

    .cursor-none {
      cursor: default !important;
    }

    .white-space {
      white-space: break-spaces;
    }

    .add-task-file-upload .doc-file-upload {
      z-index: 1;
    }

    .subcateogry-name {
      background-color: rgba(205, 217, 233, 0.3);
      padding: 3px;
    }

    .user-prfoile-img {
      margin-top: 4px;
    }

    .engagement-dropdown .select-block button.dropdown-toggle {
      border: 1px solid #cdd9e9 !important;
    }

    .loading-request {
      position: absolute !important;
      left: 50%;
      top: 78px;
      z-index: 999;
      color: #000;
      font-size: 14px;
      background: #ffff99;
      padding: 5px;
      margin-left: -140px;
      border-radius: 10px;
    }

    .client-user-name {
      flex: 0 0 300px;
      max-width: 300px;
    }

    .remove-btn-client {
      flex: 0 0 70px;
      max-width: 70px;
    }

    .engagement-dropdown .btn-drop-down .select-checkbox {
      max-height: 120px !important;
    }

    .project-engagement-block {
      min-height: 37px;
    }

    .engagement-dropdown .dropdown-toggle {
      padding-left: 15px !important;
    }

    .engagement-dropdown .title {
      border: 0px;
    }

    .modal-ongoing-area {
      background: rgba(205, 217, 233, 0.3);
      background: rgba(205, 217, 233, 0.3);
      padding: 6px;
      width: 168px;
      border-radius: 5px;
    }

    #editTaskModal .filepreview-list-scroller {
      margin-top: 0px !important;
    }

    .single-file-upload [data-filepond-item-state*='invalid'] .filepond--file-status-sub {
      opacity: 1 !important;
      transition: none !important;
      font-weight: 400;
    }

    .user-profile-img-block
      .single-file-upload
      [data-filepond-item-state*='invalid']
      .filepond--file-status-sub {
      display: block;
      width: 120px;
      white-space: normal;
    }

    .file-uploader-task .filepreview-list-scroller {
      margin-top: 0px !important;
    }

    .bluesky-dropdown .dropdown-menu {
      top: -201px;
    }

    .download-icon {
      max-width: 20px;
      margin-right: 4px;
    }

    .nav-items-link,
    .nav-items-link:focus {
      background: none;
      border: none;
      color: #fff;
      font-size: 14px;
      margin: 0;
    }

    .profile-edit-block {
      width: auto;
      height: auto;
      border: 0px;
    }

    .flatpickr-weekdays .flatpickr-weekdaycontainer:nth-child(2):before {
      background-color: #fafafa;
      content: ' ';
      width: 50%;
      position: absolute;
      z-index: -1;
      margin-top: -10px;
      height: 30px;
    }

    .multiMonth .flatpickr-innerContainer:after {
      background-color: #fafafa;
      content: ' ';
      width: 50%;
      position: absolute;
      height: 80px;
      right: 0px;
      top: 0px;
      z-index: -1;
      height: 100%;
    }

    @media print {
      .column-unit-name {
        white-space: normal;
      }

      .overflow-hidden {
        overflow: visible !important;
      }

      @page {
        size: A4 landscape;
      }

      .accordion-collapse {
        display: block !important;
      }

      * {
        overflow: visible !important;
      }

      div {
        page-break-after: always;
      }

      body {
        overflow: visible;
      }

      .filter-content.top-menu-filter,
      .web-header {
        display: none;
      }

      .block-header.mb-2 {
        display: none;
      }

      .page-content {
        overflow-y: visible;
      }

      .task-outlook {
        page-break-before: always;
      }

      .ql-editor {
        border-bottom: 1px solid #cdd9e9;
      }

      /* visible when printed */
    }

    .flatpickr-current-month span.cur-month {
      background: white !important;
    }

    .pclassp p {
      margin: auto;
    }

    .pclassp s,
    .ql-editor s {
      text-decoration: line-through !important;
    }

    .pclassp u,
    .ql-editor u {
      text-decoration: underline !important;
    }

    .pclassp blockquote {
      border-left: 4px solid #ccc;
      margin-bottom: 5px;
      margin-top: 5px;
      padding-left: 16px;
    }

    .ql-mention-list-item {
      line-height: 16px !important;
      font-size: 14px !important;
      padding: 5px 20px !important;
    }

    /*.first-col {
		position: absolute;
		width: 5.6em;
		margin-left: -5.7em; background:#ffffff;
		}
		.table-wrapper {
		overflow-x: scroll;
		margin: 0 0 0 5.3em;
		}*/
    .ql-editor,
    .ql-toolbar {
      background-color: white;
      padding: 8px 15px !important;
    }

    .ql-toolbar {
      background-color: white;
      padding-left: 8px !important;
      padding-right: 8px !important;
      border-radius: 4px 4px 0px 0px;
    }

    .ql-mention-list-container {
      width: 350px !important;
    }

    .quill-white .ql-editor,
    .quill-white .ql-toolbar,
    .quill-white .ql-container {
      border-color: white !important;
    }

    .ql-editor {
      border-bottom: 1px solid $input-border-color;
    }

    .ql-container.ql-snow,
    .ql-toolbar.ql-snow {
      border-color: $input-border-color !important;
    }

    .ql-mention-list-item {
      font-size: 13px !important;
      font-weight: 400 !important;
    }

    .ql-container {
      font-family: 'Poppins', sans-serif !important;
    }

    .ql-mention-list-container {
      box-shadow: none !important;
      border: 1px solid $input-border-color !important;
    }

    .mention,
    .ql-mention-list-item.selected {
      background-color: rgba(205, 217, 233, 0.3) !important;
    }

    .comments-block .ql-toolbar.ql-snow {
      border-top: 0px !important;
      border-left: 0px !important;
      border-right: 0px !important;
    }

    .comments-block .ql-editor {
      border-left: 0px;
      border-right: 0px;
      padding-right: 60px !important;
    }

    .comments-block .ql-container.ql-snow,
    .comments-block .ql-toolbar.ql-snow {
      border-left: 0px;
      border-right: 0px;
    }

    .listContainer .listItem .item {
      overflow: unset;
      white-space: break-spaces;
      line-height: 21px;
      display: flex;
      align-items: center;
      height: auto;
      font-size: 12px;
      min-height: 32px;
      padding: 5px 10px 5px 20px;
    }

    /* Fixing field overriding the dropdowns */
    .listContainer {
      z-index: 9999;
      min-width: 190px !important;
    }

    .table-assign-task {
      .checkbox {
        margin-right: 0px;
      }
    }

    .assign-task-table td,
    .assign-task-table th {
      padding-left: 2px !important;
      padding-right: 2px !important;
    }

    .assign-task-table .checkbox {
      margin-right: 0px;
    }

    .close-tagy-btn {
      line-height: 8px;
      background-color: rgb(144 144 170) !important;
      top: 10px !important;
      right: 10px;
      height: 22px;
      width: 22px;
      border-radius: 30px;
      border: 0px;
      padding: 0;
    }

    .priority-dropdown > button,
    .risk-rank-dropdown > button {
      background: rgba(205, 217, 233, 0.4) !important;
      width: 100%;
      text-align: left;
    }

    .priority-dropdown-modal > button > span {
      display: block;
      width: 100% !important;
    }

    .priority-dropdown-modal .dropdown-toggle::after {
      top: 9px;
      right: 8px;
      position: absolute;
    }

    .comments-list u {
      text-decoration: underline !important;
    }

    .comments-list s {
      text-decoration: line-through !important;
    }

    .btn-report-filter button {
    }

    .btn-reg-filter {
      position: relative;
    }

    .btn-reg-filter .remove-btn {
      /*display: none;*/
      position: absolute;
      right: -3px;
      top: -4px;
      width: 17px;
      background: $lead-color !important;
      width: 16px;
      height: 16px !important;
      border-radius: 6px !important;
      line-height: 0px;
      padding: 0px;
      z-index: 1;

      img {
        width: 8px;
      }

      &:hover {
        background: $black-color !important;
      }
    }

    .ql-editor table tr td,
    .ql-editor table tr th {
      border: 1px solid #cdd9e9 !important;
    }

    @media only screen and (max-width: 1750px) {
      input[type='text'].input-manager-view {
        width: 145px !important;
      }
    }

    .task-outlook-grid {
      .tabulator-headers {
        background-color: #fafafa;
      }

      .tabulator-col-title {
        font-size: 0.625rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        line-height: 1.6;
        color: #656d77;
      }

      .tabulator .tabulator-header .tabulator-col {
        border-right: 0px;
      }

      .tabulator .tabulator-header {
        border-bottom: 0px;
      }

      .tabulator-row .tabulator-cell {
        border-right: 0px;
        border-bottom: 1px solid #cdd9e9;
        color: #6c757d !important;
      }

      .tabulator-row.tabulator-row-even {
        background-color: transparent;
      }

      .tabulator-row.tabulator-selectable:hover {
        background-color: transparent !important;
      }

      .tabulator-tree-level-0 {
        font-weight: 600;
        background-color: #ebf0f6 !important;
        transition: all 0.2s ease-in-out;
      }

      .tabulator-row.tabulator-selectable.tabulator-tree-level-0:hover {
        background-color: #ebf0f6 !important;
      }

      .tabulator .tabulator-header .tabulator-col .tabulator-col-content {
        padding: 10px 4px;
      }

      .tabulator-row .tabulator-cell {
        padding: 10px 4px;
        align-content: center;
      }

      .tabulator-row.tabulator-tree-level-0 .tabulator-cell {
        overflow: visible !important;
      }

      .tabulator-row .tabulator-cell .tabulator-data-tree-branch {
        display: none !important;
      }

      .tabulator-row
        .tabulator-cell
        .tabulator-data-tree-control
        .tabulator-data-tree-control-collapse {
        background-image: url('/images/cheveron-down.svg');
        width: 20px;
        height: 20px;
        transform: rotate(180deg);
      }

      .tabulator-data-tree-control {
        width: 20px !important;
        height: 20px !important;
        background-color: transparent;
        border: 0px !important;
      }

      .tabulator-row .tabulator-cell .tabulator-data-tree-control {
        background-color: transparent;
        position: absolute;
        left: calc(94vw);
        z-index: 10000;
      }

      .tabulator-row
        .tabulator-cell
        .tabulator-data-tree-control
        .tabulator-data-tree-control-collapse:after,
      .tabulator-row
        .tabulator-cell
        .tabulator-data-tree-control
        .tabulator-data-tree-control-expand:after {
        opacity: 0;
      }

      .tabulator-data-tree-control-expand {
        background: url('/images/cheveron-down.svg') transparent !important;
        width: 20px !important;
        height: 20px !important;
        background-color: transparent;
      }

      .tabulator .tabulator-tableholder {
        overflow-x: hidden;
      }
    }
  </style>
  <!-- <style src="styles/globals.scss"></style> -->
</svelte:head>
<Router url={url}>
  {#if loadingState}
    <div class="loading-request">
      <span>Processing your request. Please Wait.</span>
      <Loader />
    </div>
  {/if}
  <div
    class="page {isLoggedIn || publicPage ? '' : 'd-none'} h-100 font-size-12 d-flex flex-column"
  >
    {#if isLoggedIn}
      <Header />
    {/if}
    {#if publicPage || checkState !== 'pending'}
      <div class="page-content h-100">
        <Route
          path="/test"
          component={Test}
        />
        <Route
          path="/"
          component={Dashboard}
        />
        <Route
          path="invalid-access"
          component={InvalidAccess}
        />
        <Route
          path="success"
          component={SuccessScreen}
        />
        <Route
          path="task"
          component={Home}
        />
        <Route
          path="client"
          component={Client}
        />
        <Route
          path="tasklibrary"
          component={TaskLibrary}
        />
        <Route
          path="tasklibrary/import"
          component={TaskLibraryImport}
        />
        <!-- <Route path="tasklibrary/import-activity-type" component="{TaskLibraryImportActivityType}" /> -->
        <Route
          path="client/import"
          component={ClientImport}
        />
        <Route
          path="client/fund-import"
          component={ClientFundImport}
        />
        <Route
          path="user"
          component={User}
        />
        <Route
          path="user/import"
          component={UserImport}
        />
        <Route
          path="user/add"
          component={AddUser}
        />
        <Route
          path="user/edit/:id"
          component={AddUser}
        />
        <Route
          path="setup-password/:code"
          component={SetupPassword}
        />
        <Route
          path="home"
          component={Dashboard}
        />
        <Route
          path="notifications"
          component={Notifications}
        />
        <Route
          path="redirect/:section"
          component={Redirect}
        />
        <Route
          path="client/add/:id"
          component={AddClient}
        />
        <Route
          path="client/edit/:id"
          component={AddClient}
        />
        <Route
          path="activitylog"
          component={ActivityLog}
        />
        <Route
          path="profile"
          component={UserProfile}
        />
        <Route
          path="assigntask"
          component={AssignTask}
        />
        <Route
          path="settings/:id"
          component={Settings}
        />
        <!-- When path is not matching, should redirect to home page -->
        <Route
          path="/*"
          component={Redirect}
        />
      </div>
    {/if}
  </div>
</Router>
<AlertModel bind:this={alertModel} />
<OverlayModel bind:this={overlayModel} />
